var LABEL_MULTIPLIER = 0.7;
var LABEL_PADDING = 5;
var C = {
	LABEL_MULTIPLIER: LABEL_MULTIPLIER,
	LABEL_PADDING: LABEL_PADDING
};

export { LABEL_MULTIPLIER, LABEL_PADDING, C as default };
